export default class Permission {
  id?: number;
  name!: string;
  code!: string;
  createdAt?: Date;
  updatedAt?: Date;
}
